// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"6ad83b4f","134":"deddad40","504":"38d840c0"}[chunkId] + ".css";
};